import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RsNgModalComponent } from './rs-ng-modal.component';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzTableModule } from 'ng-zorro-antd/table'
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { RsNgMapBmapModule } from 'rs-ng-charts';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RsNgBaseModule, baseCompList } from 'rs-ng-base';
import { RsNgCommonModule } from 'rs-ng-common';

@NgModule({
  declarations: [
    RsNgModalComponent
  ],
  imports: [
    CommonModule,
    NzDescriptionsModule,
    NzModalModule,
    NzTableModule,
    RsNgMapBmapModule,
    NzPopconfirmModule,
    NzTreeModule,
    NzIconModule,
    RsNgBaseModule,
    RsNgCommonModule,
  ],
  exports: [
    RsNgModalComponent
  ],
  entryComponents: [
    ...baseCompList
  ]
})

export class RsNgModalModule {
}
